import { Add } from "@material-ui/icons"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { ButtonDropdown, TabLog, TabsComponent } from "../../../../component/index.jsx"
import { ENUM_LOG } from "../../../../constants/InitTypeConstants.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { KPI_GOAL_SETTING_TAB } from "../../../../constants/StringConstant.js"
import { setDataTabMultiple } from "../../../../redux/actions/FilterAction.js"
import { KpiGoalSettingHistory } from "./tab/KpiGoalHistoryPage.jsx"
import { KPIGoalThisYear } from "./tab/KPIGoalThisYear.jsx"
import { loadUserLogin } from "../../../../config/index.jsx"

export function KPIGoalSetting({ history }) {
  const subheader = useSubheader()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { tabs, regionalId, year } = useParams()
  const { FieldOfficer } = useSelector((state) => state)
  const [buttonDropdownList, setButtonDropdownList] = useState([])
  const user = loadUserLogin()

  const [tabActive, setTabActive] = useState(
    tabs === KPI_GOAL_SETTING_TAB.THIS_YEAR
      ? 0
      : tabs === KPI_GOAL_SETTING_TAB.HISTORY
        ? 1
        : tabs === KPI_GOAL_SETTING_TAB.LOG
          ? 2
          : 0
  )

  const renderComponent = () => {
    const steps = [
      t("label_this_year_target"),
      t("label_history").toUpperCase(),
      t("label_log").toUpperCase()
    ]
    const flows = [
      <KPIGoalThisYear key={KPI_GOAL_SETTING_TAB.THIS_YEAR} regionalId={regionalId} year={year} />,
      <KpiGoalSettingHistory key={KPI_GOAL_SETTING_TAB.HISTORY} regionalId={regionalId} />,
      <TabLog
        key={KPI_GOAL_SETTING_TAB.LOG}
        historyTabEnum={ENUM_LOG.TARGET}
        id={regionalId}
      />
    ]

    return {
      steps,
      flows
    }
  }

  const changeTabs = (data) => {
    dispatch(setDataTabMultiple(data))
    setTabActive(data)
    if (data === 0) {
      history.push(RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(regionalId, KPI_GOAL_SETTING_TAB.THIS_YEAR, year))
    } else if (data === 1) {
      history.push(RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(regionalId, KPI_GOAL_SETTING_TAB.HISTORY, year))
    } else if (data === 2) {
      history.push(RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(regionalId, KPI_GOAL_SETTING_TAB.LOG, year))
    }
  }
  
  function hasTargetAvailable(pageData) {
    if (!pageData || pageData.length === 0) return false
    return pageData.some((srItem) => srItem?.crop_data?.some((val) => val?.id != null))
  }

  function checkDisableSettingTarget() {
    if (FieldOfficer?.pageData) {
      return hasTargetAvailable(FieldOfficer?.pageData)
    } else {
      return true
    }
  }

  useEffect(() => {
    const dataDropdown = [
      {
        title: t("dropdown_yearly_target"),
        showed: true,
        disabled: checkDisableSettingTarget(),
        action: () => {
          history.push(RoutesConstants.FIELD_OFFICER.CREATE_SETTING_TARGET_FORM(regionalId))
        }
      },
      {
        title: t("dropdown_forecast"),
        showed: true,
        disabled: true,
      }
    ]
    setButtonDropdownList(dataDropdown)
  }, [FieldOfficer])

  useEffect(() => {
    subheader.setTitle(t("sub_header_kpi_goal_setting"))
    subheader.setButton(
      <ButtonDropdown icon={<Add />} variant={"primary"} title={t("button_setting_target")} dropdownList={buttonDropdownList} />
    )
    if (!user?.regional_id) {
      subheader.setBreadcrumbs([
        {
          pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING_INDEX(),
          title: t("sub_header_all_regional")
        },
        {
          title: t("sub_header_kpi_goal_setting")
        }
      ])
    } else {
      subheader.setBreadcrumbs([])
    }
    return (() => {
      subheader.setTitle(null)
      subheader.setButton(null)
      subheader.setBreadcrumbs([])
    })
  }, [buttonDropdownList])

  return (
    <>
      <RowModule>
        <TabsComponent
          labelTab={renderComponent().steps}
          componentTab={renderComponent().flows}
          initValue={tabActive}
          changeTab={changeTabs}
        />
      </RowModule>
    </>
  )
}
